import React, { useEffect } from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const DeletedLabManagement = ({
  tableRef,
  onMouseDown,
  labManagementDeletedRows,
  softDeleteRestoreStudyLabManagementRow,
  Show,
  Hide,
  Title,
  getDeletedStudyLabManagementRowData,
  labManagementDeletedRowsCount,
  pageNumberDeleted,
  itemsPerPageDeleted,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
  siteList,
  setSiteUniqueId,
  siteUniqueId
}) => {
  
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(labManagementDeletedRowsCount / itemsPerPageDeleted);
  useEffect(() => {
    getDeletedStudyLabManagementRowData(siteUniqueId, pageNumberDeleted, itemsPerPageDeleted);
  }, [siteUniqueId, pageNumberDeleted, itemsPerPageDeleted]);
  useEffect(() => {
    setSiteUniqueId(siteList[0]?.siteId);
  }, [siteList]);
  
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="p-2">
            <Form.Select
              value={siteUniqueId}
              onChange={(e) => setSiteUniqueId(e.target.value)}
            >
              <option value="" hidden>
                Select Site
              </option>
              {siteList.map((item, index) => (
                <option key={index} value={item.siteId}>
                  {item.row?.SITEID}
                </option>
              ))}
            </Form.Select>
          </div>
          {labManagementDeletedRows?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"Lab data not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Test Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Test Label</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {labManagementDeletedRows?.map((row, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{row?.row?.["TESTNAME"]}</td>
                      <td>{row?.row?.["TESTLABEL"]}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreStudyLabManagementRow(
                              row?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={labManagementDeletedRowsCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedLabManagement;
